import React, { useEffect, useState } from "react";
import MissionHeader from "../components/missionHead";
import OurContact from "../components/ourContact";
import Wrapper from "./wrapper";
import aboutUsImg from "../assets/images/aboutUsCac.svg";
import { getTeam, subscribeToSiteSettings, INITIAL_WEBSITE_DATA } from "../lib/firestoreContent";

// Import images
import gladys from "../assets/images/team/gladys.svg";
import josh from "../assets/images/team/josh.svg";
import deji from "../assets/images/team/deji_steven.svg";
import jeddy from "../assets/images/team/jeddy.svg";
import nehhy from "../assets/images/team/nehhy.svg";
import lesh from "../assets/images/team/lesh.svg";
import issues from "../assets/images/team/issues.svg";
import debby from "../assets/images/team/debby.svg";
import shally from "../assets/images/team/shally.svg";
import ariel from "../assets/images/team/ariel.svg";
import samuel from "../assets/images/team/sam.svg";

const fallbackTeamImages = {
  "Olubowale Gladys": gladys,
  "Joshua Wisdom Momo": josh,
  "Adesanya Deborah": debby,
  "Stephen Adeniyi Deji": deji,
  "Nehemiah Amedu Odagboyi": nehhy,
  "Jedidiah Oladepo Ifeoluwa": jeddy,
  "Ekundayo Shallom": shally,
  "Lesh Tayo": lesh,
  "Iseoluwa Gbotemi": issues,
  "Ariel Hne": ariel,
  "Samuel Oghuwun": samuel,
};

// Baseline team data
const initialTeamMembers = [
  { id: "team-1", name: "Olubowale Gladys", role: "Founder", image: gladys },
  { id: "team-2", name: "Joshua Wisdom Momo", role: "Operations Director / Program Director", image: josh },
  { id: "team-3", name: "Adesanya Deborah", role: "Community Manager / Content Writer", image: debby },
  { id: "team-4", name: "Stephen Adeniyi Deji", role: "Assistant Operations Director / Program Director", image: deji },
  { id: "team-5", name: "Nehemiah Amedu Odagboyi", role: "Human Resource Director", image: nehhy },
  { id: "team-6", name: "Jedidiah Oladepo Ifeoluwa", role: "Graphic Designer", image: jeddy },
  { id: "team-7", name: "Ekundayo Shallom", role: "Developer", image: shally },
  { id: "team-8", name: "Lesh Tayo", role: "UI/UX Designer", image: lesh },
  { id: "team-9", name: "Iseoluwa Gbotemi", role: "Developer", image: issues },
  { id: "team-10", name: "Ariel Hne", role: "Community Manager / Content Writer", image: ariel },
  { id: "team-11", name: "Samuel Oghuwun", role: "Teen Coach - STEM", image: samuel },
];

const About = () => {
  const [team, setTeam] = useState(initialTeamMembers);
  const [vision, setVision] = useState(INITIAL_WEBSITE_DATA.settings.visionText);

  useEffect(() => {
    const unsubscribeSettings = subscribeToSiteSettings((settings) => {
      if (settings?.visionText) {
        setVision(settings.visionText);
      }
    });

    const loadTeam = async () => {
      try {
        const firestoreTeam = await getTeam();
        if (Array.isArray(firestoreTeam) && firestoreTeam.length > 0) {
          const formatted = firestoreTeam.map((member) => ({
            id: member.id,
            name: member.name,
            role: member.role,
            bio: member.bio,
            image: member.imageUrl || fallbackTeamImages[member.name] || gladys,
          }));
          setTeam(formatted);
        }
      } catch (err) {
        console.warn("Using fallback team members:", err);
      }
    };

    loadTeam();

    return () => unsubscribeSettings && unsubscribeSettings();
  }, []);

  return (
    <>
      <Wrapper>
        <MissionHeader />
        <div className="mt-20"></div>
      </Wrapper>

      {/* Vision Section */}
      <div className="px-[30px] md:px-[139px] mt-10">
        <div className="grid grid-cols-12 gap-8 md:gap-10 items-center">
          <div className="col-span-12 md:col-span-6 flex justify-center">
            <img className="m-auto w-[450px] md:w-[500px]" src={aboutUsImg} alt="About us" />
          </div>
          <div className="col-span-12 md:col-span-6">
            <h1
              style={{
                fontWeight: 550,
                fontFamily: "'Clash Display', sans-serif",
              }}
              className="text-[2.5rem] md:text-[3rem] text-dark mb-6"
            >
              Vision
            </h1>
            <p
              style={{
                fontWeight: 300,
                fontFamily: "'Clash Display', sans-serif",
              }}
              className="text-left text-dark text-[18px] md:text-[22px] leading-relaxed"
            >
              {vision}
            </p>
          </div>
        </div>
      </div>

      {/* Meet The Team */}
      <Wrapper>
        <section
          style={{
            fontFamily: "'Montserrat', sans-serif",
          }}
          className="px-[30px] md:px-[139px] py-[60px] mt-20"
        >
          <h1
            style={{
              fontWeight: 600,
              fontFamily: "'Clash Display', sans-serif",
            }}
            className="text-center mb-16 text-[2.5rem] md:text-[3rem] text-dark"
          >
            Meet The Team
          </h1>

          {/* Team grid */}
          <div className="grid grid-cols-12 gap-10 md:gap-12">
            {team.map((member) => (
              <div
                key={member.id || member.name}
                className="col-span-12 sm:col-span-6 md:col-span-3 mb-8"
              >
                <div className="m-auto w-fit text-center">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="m-auto rounded-2xl shadow-lg w-[280px] md:w-[300px] h-[320px] object-cover hover:scale-105 transition-transform duration-300"
                  />
                  <div className="mt-4">
                    <p
                      className="text-black text-[18px] md:text-[20px] font-semibold"
                      style={{ fontFamily: "'Clash Display', sans-serif" }}
                    >
                      {member.name}
                    </p>
                    <span className="text-[15px] md:text-[17px] block text-gray-700 leading-snug">
                      {member.role}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </Wrapper>

      <OurContact />
    </>
  );
};

export default About;
